import styled from "styled-components/macro";

export const MarketplaceWrapperStyle = styled.div`
  .go-back-wrapper {
    display: flex;
    align-items: center;

    .go-back-icon {
      border-radius: 50%;
      display: flex;
      align-items: center;
      cursor: pointer;

      &:hover {
        background-color: var(--Neutral-4);
      }

      svg {
        margin: 10px;
      }
    }

    .update-text-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 4px;

      .truncate-text {
        color: var(--Neutral-100);
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        letter-spacing: -0.048px;
      }

      .company-cell {
        display: flex;
        align-items: center;
        gap: 8px;

        .placeholder-logo {
          border-radius: 50%;
          background: var(--Brand-8);
          padding: 6px;
          display: flex;
          align-items: center;

          svg {
            width: 20px;
            height: 20px;
          }
        }

        img {
          border-radius: 50%;
          width: 32px;
          height: 32px;
        }
      }
    }
  }

  .talent-agency-table-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export const CardFlexWrapperStyles = styled.div`
  display: flex;
  gap: 16px;
`;

export const TableWrapperStyles = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  padding: 8px 0 0 0;

  .filter-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;

    .filter-bar-menus {
      display : flex;
      flex-direction : row;
      gap : 8px; 
      
      .status-width {
        min-width : 160px;
      }
      .service-width {
        min-width : 210px;
      }
      
    }
  }
  
  
`;

export const CardWrapperStyles = styled.div`
  border-radius: 8px;
  border: 1px solid var(--Neutral-8);
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;

  .card-list {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;

    svg {
      width: 16px;
      height: 16px;
    }

    .card-title {
      color: var(--Neutral-100);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.014px;
    }
  }

  .card-count {
    color: var(--Neutral-100);
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.04px;
  }
`;
